import { HStack, IconButton } from "@chakra-ui/react"
import {
  EDITOR_LAYERING,
  useEditorDispatch,
  useEditorUI
} from "@pathwright/blocks-engine"
// import IconButton from "@pathwright/ui/src/components/button/IconButton"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import styled from "styled-components"
import CopyLinkButton from "../block/CopyBlockLink"
import BlockLayoutSwitcher from "./BlockSelector/BlockLayoutSwitcher"
import BlockStylesMenu from "./BlockStyles/BlockStylesMenu"

const BlockControlsWrap = styled.div`
  width: calc(100% - 10px);
  height: 30px;
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: ${EDITOR_LAYERING.CONTROLS};
  display: flex;
  gap: 0;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;

  .OverlayTrigger {
    cursor: pointer;
  }

  .Tooltip__trigger.OverlayTrigger .Overlay {
    height: 0;
    width: 0;
    position: relative;

    & > div {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .chakra-button {
    min-width: 0;
    cursor: pointer;
    background-color: transparent;
    padding: 0;
    width: 1em;
    min-width: 1em;
    margin: 0;

    &:hover {
      background-color: transparent;
    }
  }
`

const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
`

const Controls = ({ children }) => {
  return (
    <HStack
      color="#666"
      bgColor="#efefef"
      borderRadius="20px"
      padding="5px 10px"
      margin="0px 2px"
      width="auto"
      alignItems="center"
      justifyContent="center"
      pointerEvents="all"
      fontSize="0.9em"
      sx={{
        "& > .IconButton": {
          marginRight: "5px"
        },
        ".Tooltip__trigger": {
          marginRight: "5px"
        }
      }}
    >
      {children}
    </HStack>
  )
}

const BlockControls = (props) => {
  const {
    onDelete,
    onMoveUp,
    onMoveDown,
    onCopy,
    blockType,
    block,
    blockIndex,
    onSelectLayout
  } = props

  const { layout } = block
  const { layouts } = blockType

  const { setControlIsOpen, controlIsOpen } = useEditorUI()

  const { handleUpdateBlockStyles: onChangeBlockStyles } = useEditorDispatch()

  const handleUpdateBlockStyles = (styles) => {
    onChangeBlockStyles(block, styles)
  }

  const helpLink =
    layouts[layout] && layouts[layout].helpLink
      ? layouts[layout].helpLink
      : blockType.helpLink

  return (
    <BlockControlsWrap className="BlockControls" blockIndex={blockIndex}>
      <ControlsWrapper>
        <Controls>
          <BlockLayoutSwitcher
            block={block}
            onSelectLayout={onSelectLayout}
            onOpenMenu={() => setControlIsOpen(true)}
            onCloseMenu={() => setControlIsOpen(false)}
            preventTooltip={controlIsOpen}
          />
          <BlockStylesMenu
            currentStyles={block.style}
            onChangeStyles={handleUpdateBlockStyles}
            onOpenMenu={() => {
              setControlIsOpen(true)
            }}
            onCloseMenu={() => setControlIsOpen(false)}
            preventTooltip={controlIsOpen}
          />
        </Controls>
      </ControlsWrapper>
      <Controls>
        <Tooltip title="Move block up one position">
          <IconButton
            icon={<Pathicon icon="arrow-up" />}
            color="#666"
            onClick={onMoveUp}
            size={18}
          />
        </Tooltip>
        <Tooltip title="Move block down one position">
          <IconButton
            icon={<Pathicon icon="arrow-down" />}
            color="#666"
            onClick={onMoveDown}
            size={18}
          />
        </Tooltip>
        <Tooltip title="Copy this block">
          <IconButton
            icon={<Pathicon icon="copy" />}
            color="#666"
            onClick={onCopy}
            size={18}
          />
        </Tooltip>
        <Tooltip title="Delete this block">
          <IconButton
            icon={<Pathicon icon="trash" />}
            color="#666"
            onClick={onDelete}
            size={18}
          />
        </Tooltip>
        <Tooltip title="Get a link to this block">
          <CopyLinkButton block={block} />
        </Tooltip>
        {helpLink ? (
          <Tooltip title="Get tips for using this block">
            <IconButton
              icon={<Pathicon icon="info-circle" />}
              as="a"
              color="#666"
              target="_blank"
              href={helpLink}
              size={18}
            />
          </Tooltip>
        ) : null}
      </Controls>
    </BlockControlsWrap>
  )
}

export default BlockControls
